import { GetStaticPaths } from 'next'
import { getNewsletterPageProps } from 'props-getters/newsletter'
import { ExtractGetterProps } from 'shared-definitions/util-types'
import PageContainer from 'shared-components/service/PageContainer'
import NewsletterPageTemplate from 'templates/NewsletterPageTemplate'
import Layout from 'components/Layout'

const NewsletterPage: React.VFC<ExtractGetterProps<typeof getNewsletterPageProps>> = ({
  page,
  common,
  ts,
  preview,
}) => (
  <PageContainer layoutProps={{}} layout={Layout} props={{ preview, page, common, ts }}>
    <NewsletterPageTemplate page={page} />
  </PageContainer>
)

// eslint-disable-next-line @typescript-eslint/require-await
export const getStaticPaths: GetStaticPaths = async () => ({
  paths: [],
  fallback: 'blocking',
})

export const getStaticProps = getNewsletterPageProps()

export default NewsletterPage
